module.exports = __webpack_public_path__ + "static/media/2_en.9f10daaa.png";